import React, {useEffect, useState} from "react";
import countries from "../data/countries.json";
import {apiRequest, getUsers} from "../api"; // Import the apiRequest method

const AddCRMModal = ({university, onClose, onSave}) => {
    const [CRMName, setCRMName] = useState("");
    const [crmUser, setCrmUser] = useState("");
    const [crmPassword, setCrmPassword] = useState("");
    const [crmEndpoint, setCrmEndpoint] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const [feedbackMessage, setFeedbackMessage] = useState(null); // Feedback state
    const [users, setUsers] = useState([]); // State for user list

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token"); // Retrieve token from local storage

    useEffect(() => {
        if (university) {
            setCRMName(university.crm_name);
            setCrmUser(university.crm_user);
            setCrmPassword(university.crm_password);
            setCrmEndpoint(university.crm_endpoint);
            console.log(university)
        } else {
            setCRMName("");
            setCrmUser("");
            setCrmPassword("");
            setCrmEndpoint("");
        }

    }, [university]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            crm_name:CRMName,
            crm_user:crmUser,
            crm_password: crmPassword,
            crm_endpoint: crmEndpoint,
        };

        const url =  `${apiUrl}/university/crm/${university.id}`;
        const method = "PUT" ;

        setIsLoading(true);
        setFeedbackMessage(null); // Clear previous feedback

        try {
            const response = await apiRequest(url, method, payload, token);
            console.log(
                `University ${university ? "updated" : "created"} successfully:`,
                response
            );

            // Set success feedback message
            setFeedbackMessage(
                `CRM Details updated successfully!`
            );

            // Delay before closing the modal to allow the user to see the message
            setTimeout(() => {
                onSave();
                onClose();
            }, 2000); // 2-second delay
        } catch (error) {
            console.error(
                `Error updating university CRM Details`,
                error
            );
            setFeedbackMessage(
                `Failed update university CRM details. Please try again.`
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                }}
            >
                <h4>{university ? "Edit University" : "Add New University"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>CRM Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={CRMName}
                            onChange={(e) => setCRMName(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>CRM User:</label>
                        <input
                            type="input"
                            className="form-control"
                            value={crmUser}
                            onChange={(e) => setCrmUser(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>CRM Password:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={crmPassword}
                            onChange={(e) => setCrmPassword(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>CRM Endpoint:</label>
                        <input
                            type="input"
                            className="form-control"
                            value={crmEndpoint}
                            onChange={(e) => setCrmEndpoint(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : university ? "Update" : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                    </div>
                    {feedbackMessage && (
                        <div
                            className={`alert mt-3 ${
                                feedbackMessage.includes("successfully")
                                    ? "alert-success"
                                    : "alert-danger"
                            }`}
                        >
                            {feedbackMessage}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default AddCRMModal;
